import StrategicPlanGoalsChart from "../../../../src/articles/annual-report/2020/03-planing/01-strategic-plan-goals/chart/chart-survey";
import * as React from 'react';
export default {
  StrategicPlanGoalsChart,
  React
};